<template>
  <div class="zv-page">
    <div class="zv-content">
    </div>
  </div>
</template>
<script>

export default {
  name: "Dashboard",
  mixins: [],
  components: {
  },
  data() {
    let vm = this;
    return {

    };
  },
  computed: {

  },

  methods: {

  },
  created() {

  },
  mounted() {

  },
  beforeDestroy() {

  }
};
</script>

<style lang="less" scoped>

</style>
